import { createContext } from 'react';

/**
 * Access token resolved by TokenGate via getAccessTokenSilently.
 * Single source of truth for "can call the API" — not Auth0's isAuthenticated.
 */
export const TokenContext = createContext<string | null>(null);
